import mixitup from 'mixitup';

export default {
  init() {
    (function($) {
      $( document ).ready(function() {
          var mixer = mixitup('.mix-container');
          if(mixer) {
            console.log('mix');
          }
      });
      // download form
      $('.icaal-contact-form[data-form="download"]').on('submit', function() {
      if( $(this).find('.response li') ) {
        $('.response-popup').addClass('active');
      } else {
        $('.response-popup').removeClass('active');
      }
      });

      $('.close-response-popup').click(function() {
        $('.response-popup').removeClass('active');
      });

      $('.icaal-contact-form[data-form="download"]').on('success', function() {
        $('.download-form').hide();
      });

    })(jQuery);
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/downloads.js